// extracted by mini-css-extract-plugin
module.exports = {"content":"aboutMe_content__3fVkr","profileAvatar":"aboutMe_profileAvatar__1K0Cs","profileContent":"aboutMe_profileContent__2T_gQ"};